<template>
	<div class="ex-graph-container">
		<canvas class="ex-graph" :width="width" :height="height"></canvas>
	</div>	
</template>

<script>
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

//Unregister by default
Chart.plugins.unregister(ChartDataLabels);

export default {
	name: 'Chart',
	data() {
		return {
			chart:null
		}
	},
	props: {
		type: String,
		width: Number,
		height:Number,
		values: Array,
		labels: Array,
		useBlank: Boolean,
		responsive: Boolean,
		backgroundColors: {
			type: Array,
			default: () => [
				'rgba(255, 99, 132, 0.2)', //red
				'rgba(54, 162, 235, 0.2)', //blue
				'rgba(255, 206, 86, 0.2)', //yellow
				'rgba(75, 192, 192, 0.2)', //green
				'rgba(153, 102, 255, 0.2)', //purple
				'rgba(255, 159, 64, 0.2)' //orange
			]
		},
		borderColors: {
			type: Array,
			default: () => [
				'rgba(255, 99, 132, 1)',
				'rgba(54, 162, 235, 1)',
				'rgba(255, 206, 86, 1)',
				'rgba(75, 192, 192, 1)',
				'rgba(153, 102, 255, 1)',
				'rgba(255, 159, 64, 1)'
			]
		}
	},
	computed: {
		finalValues() {
			if (!this.values || !this.values.length) return null;

			if (this.type == 'doughnut') {
				
				if (this.values.length > 2) {
					const total = this.values.reduce((sum, value) => sum += value);
					const threshold = Math.floor(total * 0.05);

					//Get any results over the threshold, and then 
					const results= this.values.filter(value => value >= threshold);
					const remains = this.values.filter(value => value < threshold);

					if (remains.length) results.push(remains.reduce((sum, value) => sum += value));
					return results;
				}
				else {
					//Dont draw anything if all zeros
					const nonzeros = this.values.filter(value => value > 0);
					if (!nonzeros.length) return [];

					return this.values;
				}
			}

			//Loop through and combine any values with the same t value
			if (this.type == 'line') {
				const results = [];
				let lastValue = null;
			
				for (var value of this.values) {
					if (lastValue != null) {
						if (value.t == lastValue.t)
						{
							lastValue.y = value.y; //already accumulative, so just move value over
							lastValue.customLabel += ', ' + value.customLabel;
							lastValue.customLabelAfter = (lastValue.additions + value.additions) + ' credentials';
						}
						else {
							results.push(value);
						}
					}
					else {
						results.push(value);
					}
					lastValue = value;
				}
				return results;
			}

			return this.values;
		},
		finalLabels() {
			if (!this.values || !this.values.length) return null;

			if (this.type == 'doughnut') {

					if (this.values.length > 2) {
					const total = (this.values.length) ? this.values.reduce((sum, value) => sum += value) : 0;
					const threshold = Math.floor(total * 0.05);

					const labels = this.labels.filter((value, index) => this.values[index] >= threshold);
					if (labels.length < this.finalValues.length) labels.push('(other)');

					return labels;						
				}
				else {
					return this.labels;		
				}
			}

			return this.labels;
		}
	},
	methods: {
		getColors(array, length) {
			var colors = [];
			while (colors.length < length) colors.push(...array);
			return colors;
		},
		drawChart() {
			//Draw a blank doughnut chart
			if (!this.finalValues || this.finalValues.length === 0) return;

			const chartElement = this.$el.firstChild,
				self = this;

			if (this.type == 'doughnut') {
				this.chart = new Chart(this.$el.firstChild,  {					
					type: 'doughnut',					
					data: {
						labels: this.finalLabels,
						datasets: [{
								data: this.finalValues,
								backgroundColor: this.getColors(this.backgroundColors, this.values.length),
								borderColor: this.getColors(this.borderColors, this.values.length),
								borderWidth: 2
						}]
					},
					options: {
						responsive: this.responsive,
						legend: {
							display: false
						}
					}
				});
			}

			if (this.type == 'line') {
				this.chart = new Chart(this.$el.firstChild,  {
					//plugins: [ChartDataLabels],
					type: 'line',
					data: {
						datasets: [{
							data: this.finalValues,
							backgroundColor: this.getColors(this.backgroundColors, this.values.length),
							borderColor: this.getColors(this.borderColors, this.values.length),
							borderWidth: 2,
							// datalabels: {
							// 	color: '#ff3333',
							// 	display: 'auto',
							// 	formatter: function(value, context) {
							// 		//console.log('value, context', value);
							// 		return value.customLabel;
							// 	}
							// }
						}]
					},
					options: {
						responsive: this.responsive,
						bezierCurve: false,
						animation: {
							onComplete() {
								self.$emit('chart-complete', this.toBase64Image());
							}
						},
						legend: {
							display: false, //dont display a legend if only one dataset
							position:'top'
						},
						scales: {
							yAxes: [{
                				ticks: {
									beginAtZero: false,
									min:0
                				}
            				}],
        			   		xAxes: [{
								type: 'time',
								time: {
									tooltipFormat: 'MMM YYYY'
								},
                				distribution: 'linear' //linear or 'series' to space out evenly
							}]
						},
						tooltips: {
							displayColors: false, //get rid of box
							callbacks: {
								label: function(tooltipItem, data) {
									return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].customLabel || ''
								},
								afterLabel: function(tooltipItem, data) {
									return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].customLabelAfter || ''
								}
							}
						}
					}
				});
			}
		}
	},
	watch: {
		finalValues(value) {
			if (this.chart) {
				this.chart.data.datasets[0].data = value;
				this.chart.update();
			}
			else {
				this.drawChart();
			}
		}
	},
	mounted() {
		this.drawChart();
	}
}
</script>




// WEBPACK FOOTER //
// src/components/Chart.vue